namespace GeniuzPOS.Purchase {
    export interface ReportDailyPIDetailData extends Serenity.ListRequest {
        para?: string;
        Shop?: string;
        DatetoDate?: string;
        Supdata?: string;
        ListHd?: ReportDailyPIRow[];
        Details?: PoPurInvoiceDtRow[];
    }
}
